"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLook = exports.getAllLookFilters = exports.getSiteFilterForLook = exports.getEmbedUriForLook = exports.getPopularLooksForCurrentOrganization = exports.searchRecentlyViewedLook = exports.searchLooksAndSync = exports.searchLooks = exports.searchLooksWithSyncUserAndRecentView = void 0;
/* eslint-disable dot-notation */
const lookDto_1 = require("../../dtos/lookDto");
const recent_1 = require("./recent");
const reportElementTypes_1 = require("../../domain/reportElementTypes");
const popular_1 = require("./popular");
const folder_1 = require("./folder");
const internalAxios_1 = require("./internalAxios");
const queryToLookFilterMapper_1 = require("../../mappers/queryToLookFilterMapper");
const queryDto_1 = require("../../dtos/queryDto");
const content_1 = require("./content");
const searchLooksWithSyncUserAndRecentView = async (searchOptions) => {
    return await (0, exports.searchLooks)(searchOptions);
};
exports.searchLooksWithSyncUserAndRecentView = searchLooksWithSyncUserAndRecentView;
const searchLooks = async (searchOptions) => {
    searchOptions.fields = lookDto_1.LookDto.QUERY_FIELDS;
    let { data } = await internalAxios_1.internalAxios.post('/api/look/search', {
        searchOptions,
    });
    data = data.map((look) => new lookDto_1.LookDto(look));
    const folderIds = await (0, folder_1.filterListofFolderIds)((0, folder_1.getUniqueListOfReportFolderIds)(data));
    const result = data.filter((reports) => folderIds?.includes(reports.folder.id));
    return result;
};
exports.searchLooks = searchLooks;
const searchLooksAndSync = async (searchOptions) => {
    return await (0, content_1.syncUser)(await (0, recent_1.syncViewCountAndDate)(reportElementTypes_1.ReportElementTypes.Look, await (0, exports.searchLooks)(searchOptions)));
};
exports.searchLooksAndSync = searchLooksAndSync;
const searchRecentlyViewedLook = async () => {
    const recentlyViewedReports = await (0, recent_1.getRecent)(reportElementTypes_1.ReportElementTypes.Look);
    if (recentlyViewedReports.length) {
        const recentlyViewedLooks = await (0, exports.searchLooks)({
            id: recentlyViewedReports
                .map((recent) => recent.reportId)
                .join(','),
        });
        return await (0, content_1.syncUser)((0, recent_1.mapReportViewCountAndDate)(recentlyViewedLooks, recentlyViewedReports));
    }
    return [];
};
exports.searchRecentlyViewedLook = searchRecentlyViewedLook;
const getPopularLooksForCurrentOrganization = async () => {
    const popularReports = await (0, popular_1.getPopularByType)(reportElementTypes_1.ReportElementTypes.Look);
    if (popularReports.length) {
        const popularLooks = await (0, exports.searchLooksAndSync)({
            id: popularReports
                .map((recent) => recent.reportId)
                .join(','),
        });
        return await (0, content_1.syncUser)(await (0, popular_1.syncReportPopularityForCurrentOrganization)(reportElementTypes_1.ReportElementTypes.Look, popularLooks, popularReports));
    }
    return [];
};
exports.getPopularLooksForCurrentOrganization = getPopularLooksForCurrentOrganization;
const getEmbedUriForLook = async (lookId) => {
    const { data } = await internalAxios_1.internalAxios.get(`/api/look/embed/${lookId}`);
    return data.uri;
};
exports.getEmbedUriForLook = getEmbedUriForLook;
const getSiteFilterForLook = async (lookId) => {
    const lookFilters = await (0, exports.getAllLookFilters)(lookId);
    return lookFilters.length === 0
        ? undefined
        : lookFilters.find((filter) => (filter.name.toLowerCase() === 'site' ||
            filter.name.toLowerCase() === 'sites.id') &&
            filter.dimension === 'sites.id');
};
exports.getSiteFilterForLook = getSiteFilterForLook;
const getAllLookFilters = async (lookId) => {
    if (!lookId) {
        return [];
    }
    const { data: lookQueryDto } = await internalAxios_1.internalAxios.get(`/api/look/${lookId}`);
    if (lookQueryDto) {
        return (0, queryToLookFilterMapper_1.queryToLookFilterMapper)(new lookDto_1.LookQueryDto({
            id: lookQueryDto.id,
            query: new queryDto_1.QueryDto({
                id: lookQueryDto.query['id'],
                model: lookQueryDto.query['model'],
                view: lookQueryDto.query['view'],
                fields: lookQueryDto.query['fields'],
                filters: lookQueryDto.query['filters'],
                filterConfig: lookQueryDto.query['filter_config'],
                filterExpression: lookQueryDto.query['filter_expression'],
                slug: lookQueryDto.query['slug'],
            }),
        }));
    }
    return [];
};
exports.getAllLookFilters = getAllLookFilters;
const createLook = async (title, folderId, modelName, dataSource) => {
    const { data } = await internalAxios_1.internalAxios.post('/api/look/', {
        title: title,
        folderId: folderId,
        model: modelName,
        view: dataSource,
    });
    return data;
};
exports.createLook = createLook;
